import { Show, Text, View, hexColor } from "@lightningtv/solid";
import {
  hidePlaylistInfo,
  playListName,
  playListPassword,
  playListUrl,
  playListUsername,
} from "../../../../state";
import { fontFamily, isRTL, t } from "../../../translations/configuration";

const Account = (props: any) => {
  // panel width
  const W = 1050;

  const expDate = localStorage.getItem("@playlistExpDate") ?? "—";
  const createdAt = localStorage.getItem("@playlistCreatedAt") ?? "—";

  return (
    <View ref={props.ref} x={isRTL() ? 200 : 600} y={150} height={600} width={1500} clipping>

      {/* ── Playlist Name row ── */}
      <View
        x={0} y={0}
        width={W} height={60}
        style={{ flexDirection: "row" }}
      >
        {/* Label */}
        <Text style={{
          fontSize: 28,
          color: hexColor("#f0f6fc"),
          fontWeight: isRTL() ? "normal" : "bold",
          fontFamily: fontFamily(),
        }}>
          {t("playName")}
        </Text>

        {/* Value — right side */}
        <Text x={1000} style={{
          fontSize: 28,
          color: hexColor("#f0f6fc"),
          fontFamily: fontFamily(),
        }}>
          {playListName()?.length > 15
            ? `${playListName().substring(0, 15)}...`
            : playListName()}
        </Text>
      </View>

      {/* ── Separator ── */}
      <View x={0} y={62} width={W} height={1} color={hexColor("#1e2a3a")} />

      {/* ── Info grid (2×2) ── */}
      <Show
        when={hidePlaylistInfo()}
        fallback={
          <View x={0} y={100}>
            {/* Row 1: Status | Expiration */}
            <View style={{ flexDirection: "row" }} gap={0}>
              {/* Status */}
              <View width={W / 2}>
                <Text style={{
                  fontSize: 25,
                  color: hexColor("#6b7280"),
                  fontFamily: fontFamily(),
                }}>
                  {t('status')}
                </Text>
                <View y={34} style={{ flexDirection: "row" }} gap={8}>
                  <View
                    y={6} width={12} height={12}
                    borderRadius={6}
                    color={hexColor("#22c55e")}
                  />
                  <Text x={20} style={{
                    fontSize: 26,
                    color: hexColor("#22c55e"),
                    fontFamily: fontFamily(),
                    fontWeight: isRTL() ? "normal" : "bold",
                  }}>
                    {t('active')}
                  </Text>
                </View>
              </View>

              {/* Expiration */}
              <View x={W / 1.8} width={W / 2}>
                <Text style={{
                  fontSize: 25,
                  color: hexColor("#6b7280"),
                  fontFamily: fontFamily(),
                }}>
                  {t('expiration')}
                </Text>
                <Text y={34} style={{
                  fontSize: 26,
                  color: hexColor("#f0f6fc"),
                  fontFamily: fontFamily(),
                }}>
                  {expDate}
                </Text>
              </View>
            </View>

            {/* Separator between rows */}
            <View y={100} width={W} height={1} color={hexColor("#1e2a3a")} />

            {/* Row 2: Max Connections | Created */}
            <View y={116} style={{ flexDirection: "row" }} gap={0}>
              {/* Max Connections */}
              <View width={W / 2}>
                <Text style={{
                  fontSize: 25,
                  color: hexColor("#6b7280"),
                  fontFamily: fontFamily(),
                }}>
                  {t('max_connections')}
                </Text>
                <Text y={34} style={{
                  fontSize: 26,
                  color: hexColor("#f0f6fc"),
                  fontFamily: fontFamily(),
                }}>
                  {t('one_device')}
                </Text>
              </View>

              {/* Created */}
              <View x={W / 1.8} width={W / 2}>
                <Text style={{
                  fontSize: 25,
                  color: hexColor("#6b7280"),
                  fontFamily: fontFamily(),
                }}>
                  {t('created')}
                </Text>
                <Text y={34} style={{
                  fontSize: 26,
                  color: hexColor("#f0f6fc"),
                  fontFamily: fontFamily(),
                }}>
                  {createdAt}
                </Text>
              </View>
            </View>

            {/* Bottom separator */}
            <View y={210} width={W} height={1} color={hexColor("#1e2a3a")} />

            {/* ── Playlist details (host / username / password) ── */}
            <View y={230}>
              {/* Host */}
              <View y={0} style={{ flexDirection: "row" }}>
                <Text style={{
                  fontSize: 25,
                  color: hexColor("#6b7280"),
                  fontFamily: fontFamily(),
                }}>
                  {t("host")}
                </Text>
                <Text x={500} style={{
                  fontSize: 25,
                  color: hexColor("#f0f6fc"),
                  fontFamily: fontFamily(),
                }}>
                  {playListUrl()?.length > 25
                    ? `${playListUrl().substring(0, 25)}...`
                    : playListUrl()}
                </Text>
              </View>

              {/* Username */}
              <View y={46} style={{ flexDirection: "row" }}>
                <Text style={{
                  fontSize: 25,
                  color: hexColor("#6b7280"),
                  fontFamily: fontFamily(),
                }}>
                  {t("username")}
                </Text>
                <Text x={500} style={{
                  fontSize: 25,
                  color: hexColor("#f0f6fc"),
                  fontFamily: fontFamily(),
                }}>
                  {playListUsername()?.length > 20
                    ? `${playListUsername().substring(0, 15)}...`
                    : playListUsername()}
                </Text>
              </View>

              {/* Password */}
              <View y={92} style={{ flexDirection: "row" }}>
                <Text style={{
                  fontSize: 25,
                  color: hexColor("#6b7280"),
                  fontFamily: fontFamily(),
                }}>
                  {t("password")}
                </Text>
                <Text x={500} style={{
                  fontSize: 24,
                  color: hexColor("#f0f6fc"),
                  fontFamily: fontFamily(),
                }}>
                  {playListPassword()?.length > 20
                    ? `${playListPassword().substring(0, 15)}...`
                    : playListPassword()}
                </Text>
              </View>
            </View>
          </View>
        }
      >
        {/* ── hidePlaylistInfo = true: show only status + expiration ── */}
        <View x={0} y={100}>
          <View style={{ flexDirection: "row" }} gap={0}>
            {/* Status */}
            <View width={W / 2}>
              <Text style={{
                fontSize: 25,
                color: hexColor("#6b7280"),
                fontFamily: fontFamily(),
              }}>
                {t('status')}
              </Text>
              <View y={34} style={{ flexDirection: "row" }} gap={8}>
                <View y={6} width={12} height={12} borderRadius={6} color={hexColor("#22c55e")} />
                <Text x={20} style={{
                  fontSize: 26,
                  color: hexColor("#22c55e"),
                  fontFamily: fontFamily(),
                  fontWeight: isRTL() ? "normal" : "bold",
                }}>
                  {t('active')}
                </Text>
              </View>
            </View>

            {/* Expiration */}
            <View x={W / 1.8} width={W / 2}>
              <Text style={{ fontSize: 25, color: hexColor("#6b7280"), fontFamily: fontFamily() }}>
                {t('expiration')}
              </Text>
              <Text y={34} style={{ fontSize: 26, color: hexColor("#f0f6fc"), fontFamily: fontFamily() }}>
                {expDate}
              </Text>
            </View>
          </View>


          <View y={130} style={{ flexDirection: "row" }} gap={0}>
            {/* Max Connections */}
            <View width={W / 2}>
              <Text style={{ fontSize: 25, color: hexColor("#6b7280"), fontFamily: fontFamily() }}>
                {t('max_connections')}
              </Text>
              <Text y={34} style={{ fontSize: 26, color: hexColor("#f0f6fc"), fontFamily: fontFamily() }}>
                {t('one_device')}
              </Text>
            </View>

            {/* Created */}
            <View x={W / 1.8} width={W / 2}>
              <Text style={{ fontSize: 25, color: hexColor("#6b7280"), fontFamily: fontFamily() }}>
                {t('created')}
              </Text>
              <Text y={34} style={{ fontSize: 26, color: hexColor("#f0f6fc"), fontFamily: fontFamily() }}>
                {createdAt}
              </Text>
            </View>
          </View>

          <View y={210} width={W} height={1} color={hexColor("#1e2a3a")} />
        </View>
      </Show>
    </View>
  );
};

export default Account;
